<div *ngIf="data">
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content>

        <vedrax-form [descriptor]="data" (onSubmit)="submit($event)" (onCancel)="cancel($event)">
        </vedrax-form>

    </div>
</div>